import styled from "styled-components";
import Submit from "../../../../components/FormikForm/Submit";
import Button from "../../../../components/Button";

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;

  @media(min-width: 768px){
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const Cancel = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;

export const Save = styled(Submit)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 18px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;

export const Subtitle = styled.p`
  font-size: 12px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;